export default __webpack_public_path__ + "static/Animation-fdd1a7f639c96c62dc8f1550a6cda3c0.mp4";